export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "searchApplicantLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search by applicant name, ID, email"])}
      },
      "fr": {
        "searchApplicantLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher par nom, ID, courriel du candidat"])}
      }
    }
  })
}
